export default function getAdminStats(ctx) {
	return {
    prefix: 'admin',
    widgets: [
      {
        type: 'multiWidget',
        widgets: [
          {
            code: 'managersCount',
            name: ctx.$t('stats.managersCount'),
            icon: 'GridIcon',
            url: '/stats/get-managers-count',
            color: 'warning',
          },
          {
            code: 'authorsCount',
            name: ctx.$t('stats.authorsCount'),
            icon: 'Edit3Icon',
            url: '/stats/get-authors-count',
            color: 'success'
          },
          {
            code: 'clientsCount',
            name: ctx.$t('stats.clientsCount'),
            icon: 'UsersIcon',
            url: '/stats/get-clients-count',
            color: 'info',
          },
        ]
      },
      {
        type: 'multiWidget',
        widgets: [
          {
            code: 'ordersCount',
            name: ctx.$t('stats.ordersCount'),
            icon: 'ListIcon',
            url: '/stats/get-orders-count',
            color: "info"
          },
          {
            code: 'paidOrdersCount',
            name: ctx.$t('stats.paidOrdersCount'),
            url: '/stats/get-orders-paid-count',
            icon: 'ShoppingCartIcon',
            color: "success"
          },
          {
            code: 'conversion',
            name: ctx.$t('stats.conversion'),
            url: '/stats/get-conversion-total',
            icon: 'AlertCircleIcon',
            color: "warning",
            symbol: '%'
          },
        ]
      },
      {
        code: 'sitesCount',
        name: ctx.$t('stats.sitesCount'),
        icon: 'GlobeIcon',
        url: '/stats/get-sites-count',
        color: "info",
        type: "widget"
      },
      {
        code: 'successRate',
        name: ctx.$t('stats.successOrder'),
        url: '/stats/get-success-rate',
        icon: 'ThumbsUpIcon',
        color: "primary",
        delimited: true,
        type: "widget"
      },
      {
        code: 'incomeTotal',
        name: ctx.$t('stats.incomeTotal'),
        url: '/stats/get-income-total',
        icon: 'CreditCardIcon',
        color: "warning",
        symbol: ' €',
        type: "widget"
      },
      {
        code: 'income',
        name: ctx.$t('stats.incomeClean'),
        url: '/stats/get-income-profit',
        icon: 'CreditCardIcon',
        color: "success",
        symbol: ' €',
        type: "widget"
      },

      {
        code: 'graphUsers',
        name: ctx.$t('stats.graphUsers'),
        url: '/stats/get-graph-users',
        type: 'chart',
        multiple_series: true
      },
      {
        code: 'graphIncome',
        name: ctx.$t('stats.graphAdminIncome'),
        url: '/stats/get-graph-income',
        type: 'chart',
        multiple_series: true
      },
      {
        code: 'graphQualityLevels',
        name: ctx.$t('stats.graphQualityLevels'),
        url: '/stats/get-graph-quality-levels',
        type: 'chart',
        multiple_series: true
      },
      {
        code: 'graphSubjects',
        name: ctx.$t('stats.graphSubjects'),
        url: '/stats/get-graph-subjects',
        type: 'chart',
        multiple_series: true
      }
    ]
  }
}
